import Axios from '../axios';
import appConfig from '../../../app.config';
import { userManager } from '../../../auth/services/auth.service'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { TFunction } from 'i18next'
import { logError } from '../../../shared';
import { IAccountStatements } from '../../interfaces/i-api-creaditCard'

async function getAccountStatementsService(t: TFunction, additionalData?: string) {
    const accountStatementFormat = 'pdf';
    let customerId = await userManager.getUser().then((user) => {
        return user?.profile.sub
    })
    const response = await Axios
        .get<IAccountStatements>(
            `${appConfig.customerDataBaseUrl}/api/creditcard/accountstatements?customerId=${customerId}&accountStatementFormat=${accountStatementFormat}&additionalData=${additionalData}`,
            await getHeadersWithJwtToken()
        )
        .then((result) => {
            return result.data as IAccountStatements
        })
        .catch((err) => {
            logError(err)
            if (err.response?.status === 404) {
                throw new Error(t('NoAccountStatements'))
            } else {
                throw err
            }
        })
    return response as IAccountStatements
}

export default getAccountStatementsService;